import React from 'react';
import FooterBase from './footer.base';
import { items } from './data/footer.data';
import Link from 'atomic/link';
import Icon from 'atomic/icon';
import ras_logo from '../../../assets/images/ras_logo.svg';
import { SeoLinkRelEnum } from 'modules/seo-module/interfaces/seo-link-rel.enum';
import { LinkTarget } from 'atomic/link/link-target.enum';

import './footer.desktop.scss';

const FooterDesktop: React.FC = () => (
    <FooterBase>
        <div className="container">
            <div className="footer__main" data-section="footer-main">
                {
                    items.map(item => (
                        <div className="footer__main__section" key={item.label}>
                            <div className="footer__main__section__header">
                                {item.label}
                            </div>
                            <ul className="footer__main__section__list">
                                {
                                    item.items.map(link => (
                                        <li key={link.href} className="footer__main__section__list__item">
                                            <Link
                                                href={link.href}
                                                target={link.target}
                                                rel={link.rel}
                                                title={link.title}
                                                size="xs"
                                                weight={link.weight ?? '400'}
                                                block={true}
                                            >
                                                {link.icon && (
                                                    <Icon name={link.icon} color="secondary" size={18} />
                                                )}
                                                {link.label}
                                            </Link>
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                    ))
                }
            </div>
            <div className="footer__aside" data-section="footer-aside">
                <div className="footer__aside__top">
                    <Link
                        href="https://panel.moneteasy.pl"
                        title="Logowanie do Moneteasy"
                        rel={SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER}
                        type="button"
                        className="footer__aside__button"
                        color="transparent-secondary"
                        size="md"
                        target={LinkTarget.BLANK}
                    >
                        <Icon name="partner" color="secondary" size={20} />
                        Panel Partnerski
                    </Link>
                    <Link
                        href="https://panel.onetads.pl/"
                        title="Wiele narzędzi, jedna platforma: Moneteasy"
                        rel={SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER}
                        type="button"
                        className="footer__aside__button"
                        color="transparent-secondary"
                        size="md"
                        target={LinkTarget.BLANK}
                    >
                        <Icon name="pie-chart" color="secondary" size={20} />
                        Panel dla sklepów
                    </Link>
                </div>
                <div className="footer__aside__bottom">
                    <p>
                        Należymy do grupy
                    </p>
                    <div className="footer__aside__image">
                        <img
                            src={ras_logo}
                            width={100}
                            height={41}
                            alt=""
                        />
                    </div>
                </div>
            </div>
        </div>
    </FooterBase>
);

export default FooterDesktop;
